// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { RatingModule } from 'libraries/component/rating/rating.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { HotelResumeSearchComponent } from './hotel-resume-search.component';
import { HelperService } from "../../services/helper.service";
import { GeopositionModule } from 'libraries/service/geoposition/geoposition.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { GeoPositionPipesModule } from "libraries/pipes/geo-position/geo-position-pipes.module";

@NgModule({
    declarations: [
        HotelResumeSearchComponent,
    ],
    imports: [
        CommonModule,
        DatePipeModule,
        PricePipesModule,
        PricePipeModule,
        RatingModule,
        GeopositionModule,
        GeoPositionPipesModule,
    ],
    exports: [
        HotelResumeSearchComponent,
    ],
    providers: [
        HelperService,
    ]
})
export class HotelResumeSearchModule {}
